import type { CustomDrinkRecipeItem, Pagination } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'custom-drinks/recipe-items';

export function getCustomDrinkRecipeItems(
    query: CustomDrinkRecipeItem.SearchQuery
) {
    return api.get<Pagination<CustomDrinkRecipeItem>>(rootPath, query);
}

export function getCustomDrinkRecipeItem(id: number) {
    return api.get<CustomDrinkRecipeItem.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postCustomDrinkRecipeItem(
    data: CustomDrinkRecipeItem.CreateRequest
) {
    return api.post<CustomDrinkRecipeItem>(rootPath, data);
}

export function putCustomDrinkRecipeItem(
    id: number,
    data: CustomDrinkRecipeItem.UpdateRequest
) {
    return api.put<CustomDrinkRecipeItem>(`${rootPath}/${id}`, data);
}

export function deleteCustomDrinkRecipeItem({
    id,
}: CustomDrinkRecipeItem.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
